import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { post } from '../lib/api';
import { ensureVisitorId } from '../lib/visitor';
import { useCookieConsent, getCookieConsent } from '../lib/cookieConsent';
import { useAuth } from '../context/AuthContext';
const newId = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(16)); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
};
export default function VisitTracker() {
  const { analytics } = useCookieConsent();
  const location = useLocation(); const { user } = useAuth(); const last = useRef(''); const page = useRef(null);
  useEffect(() => {
    if (!analytics || !getCookieConsent().analytics) { last.current = ''; page.current = null; return; }
    const key = location.key + ':' + location.pathname + ':' + (user?._id || user?.id || 'guest');
    if (last.current === key) return;
    last.current = key;
    try {
      const now = Date.now(); const visitorId = ensureVisitorId(); let session = JSON.parse(sessionStorage.getItem('bc_visit_session') || 'null');
      if (!session || session.visitorId !== visitorId || now - session.at > 30 * 60 * 1000) session = { id: newId(), visitorId };
      session.at = now; sessionStorage.setItem('bc_visit_session', JSON.stringify(session));
      const route = session.id + ':' + location.key + ':' + location.pathname;
      if (page.current?.route !== route) page.current = { route, id: newId() };
      post('/analytics/visit', { sessionId: session.id, eventId: page.current.id }).catch(() => {});
    } catch { /* Tracking must never interrupt navigation. */ }
  }, [analytics, location.key, location.pathname, user?._id, user?.id]);
  return null;
}
